<template>
  <v-form @submit.prevent="submit">
    <v-sheet rounded class="px-6 py-4 mb-8">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            label="Jméno"
            outlined
            hide-details="auto"
            v-model="user.firstName"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Příjmení"
            outlined
            hide-details="auto"
            v-model="user.lastName"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="E-mail"
            outlined
            hide-details="auto"
            v-model="user.email"
          />
        </v-col>
      </v-row>
    </v-sheet>
    <div class="text-center">
      <v-btn color="primary" class="c-btn" type="submit">
        Aktualizovat údaje
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { call, sync } from "vuex-pathify"

export default {
  computed: {
    ...sync("auth", ["user"]),
  },
  methods: {
    ...call("auth", ["updateUser"]),
    submit() {
      this.updateUser()
    },
  },
}
</script>
